import { render, staticRenderFns } from "./SystemHealthBanner.vue?vue&type=template&id=06cbf0a8&scoped=true&"
import script from "./SystemHealthBanner.vue?vue&type=script&lang=js&"
export * from "./SystemHealthBanner.vue?vue&type=script&lang=js&"
import style0 from "./SystemHealthBanner.vue?vue&type=style&index=0&id=06cbf0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cbf0a8",
  null
  
)

export default component.exports